"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconELearningMonitor = /*#__PURE__*/
function (_Icon) {
  _inherits(IconELearningMonitor, _Icon);
  function IconELearningMonitor(props) {
    var _this;
    _classCallCheck(this, IconELearningMonitor);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconELearningMonitor).call(this, props));
    _this.name = 'IconELearningMonitor';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "e-learning-monitor_svg__group0"
    }, _react2.default.createElement("path", {
      className: "e-learning-monitor_svg__path0",
      d: "M7 22.501a.5.5 0 010-1h3v-2H1.5c-.827 0-1.5-.673-1.5-1.5v-15c0-.827.673-1.5 1.5-1.5h21c.827 0 1.5.673 1.5 1.5v15c0 .827-.673 1.5-1.5 1.5H14v2h3a.5.5 0 010 1H7zm6-1v-2h-2v2h2zm-11.5-19a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-21z"
    }), _react2.default.createElement("path", {
      className: "e-learning-monitor_svg__path1",
      d: "M4.361 16.5a.752.752 0 01-.702-1.011L5 11.909V8.5a.487.487 0 01.131-.334l.023-.025a.517.517 0 01.149-.101l6.606-2.83a1.494 1.494 0 011.182.001l5.534 2.372a.991.991 0 01.525.525.995.995 0 01.01.765.993.993 0 01-.534.548L17 10.117v3.07a.992.992 0 01-.552.895l-3.277 1.638a1.507 1.507 0 01-1.341 0l-3.277-1.638A.993.993 0 018 13.186v-3.07l-2-.858v2.651l1.341 3.578A.751.751 0 016.64 16.5H4.361zm.361-.999l1.556-.001-.778-2.075-.778 2.076zM9 13.187l3.277 1.639a.504.504 0 00.446 0L16 13.188v-2.642l-2.911 1.248a1.496 1.496 0 01-.588.119c-.205 0-.404-.04-.591-.12L9 10.544v2.643zm3.303-2.314a.511.511 0 00.396 0l5.532-2.371-5.534-2.372a.51.51 0 00-.394 0L6.769 8.5l5.534 2.373z"
    })));
    return _this;
  }
  return IconELearningMonitor;
}(_Icon3.default);
exports.default = IconELearningMonitor;